import { startOfDay as startOfDayFns } from 'date-fns';

export default function startOfDay(date: Date): Date {
  return startOfDayFns(date);
}
